export default "__VITE_ASSET__Dg2PdMQ8__"